import axios from '@/utils/axios';
import queryString from '@/utils/queryString';

export default {
    namespaced: true,
    state: {
        uom: null,
        uoms: null
    },
    mutations: {
        setUom(state, payload) {
            state.uom = payload;
        },
        setUoms(state, payload) {
            state.uoms = payload;
        }
    },
    actions: {
        storeUom({rootState, dispatch}, payload){
            return new Promise((resolve, reject)=> {
                axios.request({
                    method: "post",
                    url: `${rootState.warehouse.routePrefix}/measure-units`,
                    data: payload,
                    headers: {Authorization: `Bearer ${rootState.authentication.token}`}
                })
                .then((response)=> {
                    resolve(response)
                })
                .catch((error) => { 
                    if(error.response && error.response.status == 401) dispatch('authentication/logout',{ message: 'Session Expired! Please Login.' }, {root: true});
                    reject(error) 
                });
            })
        },
        updateUom({rootState, dispatch}, payload) {
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "put",
                    url: `${rootState.warehouse.routePrefix}/measure-units/${payload.id}`,
                    data: payload,
                    headers: {Authorization: `Bearer ${rootState.authentication.token}`}
                })
                .then((response)=> {resolve(response)})
                .catch((error) => {
                    if(error.response && error.response.status == 401) dispatch('authentication/logout',{ message: 'Session Expired! Please Login.' }, {root: true});
                    reject(error) 
                });
            })
        },
        removeUom({rootState, dispatch}, payload){
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "delete",
                    url: `${rootState.warehouse.routePrefix}/measure-units/${payload.id}`,
                    headers: {Authorization: `Bearer ${rootState.authentication.token}`}
                })
                .then((response)=> {resolve(response)})
                .catch((error) => { 
                    if(error.response && error.response.status == 401) dispatch('authentication/logout',{ message: 'Session Expired! Please Login.' }, {root: true});
                    reject(error) 
                });
            })
        },
        removeUoms({rootState, dispatch}, payload){
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "delete",
                    url: `${rootState.warehouse.routePrefix}/measure-units`,
                    data: payload,
                    headers: {Authorization: `Bearer ${rootState.authentication.token}`}
                })
                .then((response)=> {resolve(response)})
                .catch((error) => { 
                    if(error.response && error.response.status == 401) dispatch('authentication/logout',{ message: 'Session Expired! Please Login.' }, {root: true});
                    reject(error) 
                });
            })
        },
        fetchUom({commit, rootState, dispatch}, payload){
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "get",
                    url: `${rootState.warehouse.routePrefix}/measure-units/${payload}`,
                    headers: {Authorization: `Bearer ${rootState.authentication.token}`}
                })
                .then((response)=> {
                    commit("setUom", response.data)
                    resolve(response)
                })
                .catch((error) => {
                    if(error.response && error.response.status == 401) dispatch('authentication/logout',{ message: 'Session Expired! Please Login.' }, {root: true});
                    reject(error) 
                });
            })

        },
        fetchUoms({commit, rootState, dispatch}, payload){
            let query = queryString(payload);
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "get",
                    url: `${rootState.warehouse.routePrefix}/measure-units?${query}`,
                    headers: {Authorization: `Bearer ${rootState.authentication.token}`}
                })
                .then((response)=> {
                    commit("setUoms", response.data)
                    resolve(response)
                })
                .catch((error) => { 
                    if(error.response && error.response.status == 401) dispatch('authentication/logout',{ message: 'Session Expired! Please Login.' }, {root: true});
                    reject(error) 
                });
            })

        }
    }
}